import { gql } from '@apollo/client/core';

export const FETCH_ONBOARDING_STATE = gql`
  query onboardingState {
    onboardingState {
      ... on CorporateOnboardingState {
        CorporateOnboardingState: value
      }
      ... on SitterOnboardingState {
        SitterOnboardingState: value
      }
    }
  }
`;

export const SITTER_PROFILE_QUERY = gql`
  query {
    sitterProfile {
      id
      babysitterProfileCompleted
      babysitterProfileVisible
      nannyProfileCompleted
      nannyProfileVisible
      petCareProfileCompleted
      petCareProfileVisible
      companionCareProfileCompleted
      companionCareProfileVisible
      housekeepingProfileCompleted
      housekeepingProfileVisible
      location {
        cityname
        stateabbr
      }
    }
  }
`;

export const ACCOUNT_PROFILES_QUERY = gql`
  query AccountProfiles($accountId: UUID!) {
    account(id: $accountId) {
      profiles {
        babysitter {
          profileCompleted
          profileVisible
        }
        companionCare {
          profileCompleted
          profileVisible
        }
        housekeeping {
          profileCompleted
          profileVisible
        }
        nanny {
          profileCompleted
          profileVisible
        }
        petCare {
          profileCompleted
          profileVisible
        }
      }
    }
  }
`;

export default SITTER_PROFILE_QUERY;
